import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';

const company = computed(() => store.getters['company/info']);

export default {
	home() {
		return Repository.get(`/company/${company.value.id}/admin/report/home`);
	},
	general(params) {
		return Repository.get(`/company/${company.value.id}/admin/report/general`, { params: params });
	}
}